import { JSX } from 'react'
import { Cross1Icon } from '@radix-ui/react-icons'
import { Flex } from '@radix-ui/themes'
import './side-drawer.scss'

type SideDrawerProps = {
  onClose: () => void
  children: JSX.Element | JSX.Element[]
}

export const SideDrawer = ({ onClose, children }: SideDrawerProps) => {
  return (
    <>
      <div className="side-drawer-backdrop" onClick={onClose} />
      <Flex direction="column" gap="3" className="side-drawer">
        <Cross1Icon className="close-button" onClick={() => onClose()}></Cross1Icon>
        {children}
      </Flex>
    </>
  )
}
